import { APICore } from 'src/helpers/api/apiCore';
import config from 'src/config';
const apiBaseUrl = config.API_URL;
const api = new APICore();

// add UOM
function creatUOM(params: any) {
    const baseUrl = `/uom/addUom`;
    return api.createWithFile(`${baseUrl}`, params);
}
// update UOM
function updateUOM(params: any) {
    const baseUrl = '/uom/updUom';
    return api.updatePutWithFile(`${baseUrl}`, params);
}

// get all UOM
function getAllUOM(params: any) {
    const baseUrl = '/uom/getUomList';
    return api.create(`${baseUrl}`, params);
}

// get UOM
function getUOM(params: any) {
    const baseUrl = '/uom/getUomDtl';
    return api.create(`${baseUrl}`, params);
}

export { creatUOM, updateUOM, getAllUOM, getUOM };
